import { useState, useCallback } from "react";
import styles from "./AniadirSeccion.module.css";
import { 
    Monitor, 
    FileText,
    FileDown,
    Clapperboard,
    School,
} from 'lucide-react';

const AniadirSeccion = ({abrirModal, cerrarModal, pasoId, onCrearSeccion}) => {
    const [plantillaSeleccionada, setPlantillaSeleccionada] = useState(null);
    const[isClosing, setIsClosing] = useState(false); 
    
    const plantillas = [
        {
            id: 1,
            nombre: "Plantilla con URL",
            icono: Monitor,
            descripcion: "Añade una presentación tipo link",
            color: "#4F46E5"
        },
        {
            id: 2,
            nombre: "Plantilla con presentación PDF",
            icono: FileText,
            descripcion: "Sube tu presentacion en formato PDF",
            color: "#059669"
        },
        {
            id: 3,
            nombre: "Plantilla para Ejercicios",
            icono: FileDown,
            descripcion: "Añade un PDF con ejercicios para el alumno",
            color: "#DC2626"
        },
        {
            id: 4,
            nombre: "Plantilla con Video",
            icono: Clapperboard,
            descripcion: "Implementa un video desde la web",
            color: "#7C3AED"
        },
        {
            id: 5,
            nombre: "Plantilla con Elemento Cargado",
            icono: School,
            descripcion: "Agrega un elemento previamente guardado",
            color: "#f7b32cff"
        },
    ];
    // Opción 1: Usando useCallback para evitar re-renders
    const seleccionarPlantilla = useCallback((plantillaId) => {
        setPlantillaSeleccionada(plantillaId);
    }, []);

    const confirmarSeleccion = () => {
        const plantilla = plantillas.find(p => p.id === plantillaSeleccionada);
            // Mapear los tipos de archivo según la plantilla seleccionada
        if(plantilla) {
            let tipoArchivo;
            switch (plantilla.id) {
                case 1:
                    tipoArchivo = 'URL';
                    break;
                case 2:
                    tipoArchivo = 'PDF';
                    break;
                case 3:
                    tipoArchivo = 'Ejercicio';
                    break;
                case 4:
                    tipoArchivo = 'Video';
                    break;
                case 5:
                    tipoArchivo = 'Componente';
                    break;
                default:
                    tipoArchivo = 'URL';
            }
            
            onCrearSeccion({
                pasoId,
                tipoArchivo,
                plantillaId: plantilla.id,
                plantillaNombre: plantilla.nombre
            })
        }
    };

    const cerrarModalAnim = () => {
        setIsClosing(true); 
        setTimeout(() => { 
            setIsClosing(false);
            cerrarModal(); 
        }, 300); 
    }; 

    const cerrarModalClick = (e) => {
        if (e.target === e.currentTarget) {
        cerrarModalAnim();
        }
    }
    
    if (!abrirModal) return null;

    return (
        <div className={styles.modalSeccion} onClick={cerrarModalClick}>
            <div className={`${styles.modalSeccionCont} ${isClosing ? styles.modalFadeOut : styles.modalAniadirAnim}`}>
                <div className={styles.modalScrollable}>
                    <button 
                        type="button" 
                        className={styles.closeBtn}
                        onClick={cerrarModalAnim}
                    >
                        &times;
                    </button>
                    <h2 className={styles.tituloModal}>Seleccionar Plantilla</h2>

                    <div className={styles.plantillasGrid}>
                        {plantillas.map((plantilla) => {
                            const IconoComponente = plantilla.icono;
                            const isSelected = plantillaSeleccionada === plantilla.id;

                            return (
                                <div 
                                    key={plantilla.id}
                                    className={`${styles.plantillaCard} ${isSelected ? styles.selected : ''}`}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        seleccionarPlantilla(plantilla.id);
                                    }}
                                >
                                    <div className={styles.plantillaImagen}>
                                        <IconoComponente 
                                            className={styles.plantillaIcon} 
                                            style={{ color: plantilla.color }}
                                        />
                                        {isSelected && (
                                            <div className={styles.checkOverlay}>
                                            </div>
                                        )}
                                    </div>
                                    <div className={styles.plantillaInfo}>
                                        <h3>{plantilla.nombre}</h3>
                                        <p>{plantilla.descripcion}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <div className={styles.modalActions}>
                        <button 
                            type="button" 
                            className={styles.botonGuardar}
                            onClick={confirmarSeleccion}
                            disabled={!plantillaSeleccionada}
                        >
                            Usar Plantilla
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AniadirSeccion;